import { useEffect, useState } from "react";
import { Tag, Copy } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Promotions() {
  const [promos, setPromos] = useState([]);
  useEffect(() => { api.get("/promotions").then(({data}) => setPromos(data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F6]" data-testid="promotions-page">
      <section className="bg-[#050505] text-[#FAF9F6] py-14 border-b border-[#D4AF37]/30">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <Tag className="w-9 h-9 text-[#D4AF37] mb-2" strokeWidth={1.5}/>
          <h1 className="font-heading text-5xl text-[#D4AF37]">Royal Promotions</h1>
          <p className="text-[#FAF9F6]/60 mt-2 max-w-xl">Exclusive deals on lechon, pancit party trays, fresh seafood, and Royal Rewards bonus points.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {promos.map((p) => (
          <div key={p.id} className="mart-card overflow-hidden" data-testid={`promo-${p.id}`}>
            {p.image && <div className="h-44 bg-cover bg-center" style={{backgroundImage:`url(${p.image})`}}/>}
            <div className="p-5">
              <span className="badge-royal">{p.applies_to.toUpperCase()}</span>
              <h3 className="font-heading text-2xl text-[#1A2421] mt-2">{p.name}</h3>
              <p className="text-sm text-[#5C6B64] mt-1 mb-4">{p.description}</p>
              <div className="flex items-center justify-between border-t border-dashed border-[#8A9A86]/40 pt-3">
                <div>
                  <div className="text-[10px] uppercase font-accent text-[#2C4A3B]">CODE</div>
                  <div className="font-mono font-bold text-lg text-[#D4AF37]">{p.code}</div>
                </div>
                <button
                  data-testid={`promo-copy-${p.id}`}
                  onClick={() => { navigator.clipboard.writeText(p.code); toast.success("Code copied"); }}
                  className="w-10 h-10 rounded-full border border-[#2C4A3B] text-[#2C4A3B] hover:bg-[#2C4A3B] hover:text-[#FAF9F6] flex items-center justify-center"
                ><Copy className="w-4 h-4" /></button>
              </div>
            </div>
          </div>
        ))}
        {promos.length === 0 && <p className="col-span-full text-center text-[#5C6B64] py-12">No active promotions.</p>}
      </div>
    </div>
  );
}
